import { ACADEMY_TOPICS } from "@/lib/academy/content";

const ITEMS = ["Coming soon", ...ACADEMY_TOPICS, "DCYB Academy"];

const Run = () => (
  <div className="flex shrink-0">
    {[...ITEMS, ...ITEMS].map((item, index) => (
      <span key={`${item}-${index}`} className="inline-flex items-center gap-3 px-5 font-space-mono text-[11px] whitespace-nowrap"><span className="academy-node" />{item}</span>
    ))}
  </div>
);

export const TeaserTicker = () => (
  <div aria-hidden="true" data-testid="academy-teaser-ticker" className="bg-[#160907] text-[#FFF6F1] overflow-hidden">
    <div className="ticker flex w-max py-3.5"><Run /><Run /></div>
  </div>
);
